import { useState } from 'react';
import React from 'react';

const initialState = {
  useSharedLang: () => {
    const [locale, setLocale] = useState("AR");
    const [lang, setLang] = useState("AR");
    const ContactRef = React.useRef();
    const aboutRef = React.useRef();
    const defineRef = React.useRef();
    const mainRef = React.useRef();
    const joinRef = React.useRef();
    const servicesRef = React.useRef();
    const arrayLang = {
      AboutUs: lang === "AR" ? "من نحن؟" : "About Us",
      subTitle:
        lang === "AR"
          ? "شركة التشفير المعاصر للحلول التقنية"
          : "Contemporary encryption company for technical solutions",
      p1:
        lang === "AR"
          ? "نظام يستخدم أحدث النظم التقنية والتكنولوجية، مؤلف من تطبيق موبايل وموقع ويب للعميل، وتطبيق ديسكتوب وموبايل للمغسل، وتطبيق موبايل لعامل التوصيل، وموقع ويب وتطبيق ديسكتوب لمدير النظام (dashboard). تم تصميم المنصة بحيث توفر قاعدة يمكن من خلالها تقديم عملية إدارية وتنظيمية شاملة لإدارة المغاسل والعملاء وعمال التوصيل ضمن المملكة العربية السعودية .يتكيف هذا النظام مع أنظمة التشغيل المختلفة من تطبيق الهاتف اللوحي إلى أنظمة تشغيل الحواسيب، بالإضافة لأنظمة الويب."
          : "A system that uses the latest technical and technological systems, consisting of a mobile application and a website for the customer, a desktop and mobile application for the laundry, a mobile application for the delivery worker, a website and a desktop application for the system manager (dashboard).The platform is designed to provide a base through which a comprehensive administrative and organizational process can be provided for the management of laundries, customers and delivery workers within the Kingdom of Saudi Arabia.This system adapts to different operating systems from the tablet phone application to computer operating systems, in addition to web systems.",
      DefineTheSystem: lang === "AR" ? "تعريف النظام" : "Define the system",
      Laundry:
        lang === "AR"
          ? "مغسل خدمات التنظيف السعودية"
          : "Saudi Laundry Cleaning Services",
      facebook:
        lang === "AR"
          ? "للمزيد من المعلومات يمكنك زيارة الصفحة الخاصة بالشركة عبر فيسبوك:"
          : "For more information, you can visit the company's Facebook page:",
      goToPage: lang === "AR" ? " الذهاب للصفحة" : "Go to Page",
      text1:
        lang === "AR"
          ? "نظام إدارة وتتبع خدمات التنظيف بدءاً من تقديم طلب التنظيف من المستخدم مروراً بعامل التوصيل حتى المغسلة، لتقديم خدمات التنظيف من كيّ وتجفيف وغسيل للملابس والأثاث ضمن المملكة العربية السعودية."
          : "A management and tracking system for cleaning services, starting from submitting a cleaning request from the user through the delivery worker to the laundromat, to provide cleaning services such as ironing, drying and washing clothes and furniture within the Kingdom of Saudi Arabia.",
      text2:
        lang === "AR"
          ? " بالإضافة لدعم خدمة الدفع الالكتروني لتسديد العمولات والفواتير خلال عملية تقديم الخدمة.يتكون النظام من العميل، عامل التوصيل، صاحب المغسل، مدير النظام."
          : "In addition to supporting the electronic payment service to pay commissions and invoices during the process of providing the service. The system consists of the customer, the delivery person, the owner of the laundry, and the system administrator.",
      download: lang === "AR" ? "تحميل الملف" : "Download File",
      text3:
        lang === "AR"
          ? "للمزيد من المعلومات عن النظام قم بتحميل الملف التالي:"
          : "For more information about the system, download the following file:",
    };

    return {
      locale,
      setLocale,
      lang,
      arrayLang,
      setLang,
      ContactRef,
      aboutRef,
      defineRef,
      mainRef,
      joinRef,
      servicesRef,
    };
  },
  userClassify: "Gold",
};

function rootReducer(state = initialState, action) {
    switch (action.type) {
        case 'UPDATE-DATE':
            return {
            }
        default:
            return state
    }
}

export default rootReducer;